export default __webpack_public_path__ + "static/media/alert-triangle-yellow.6c1acfaf.svg";